import React from 'react';

import { toISOStringWithTimezone } from '../../../../utils';
import { IPost } from '../../Post';
import { AUTHORS } from '../../../../constants/authors';

interface IMicrodata
  extends Pick<IPost, 'dateModified' | 'datePublished' | 'postUrl' | 'postId' | 'title' | 'image' | 'authorLinks'> {
  authorName?: string;
}

/**
 * Микроразметка
 */
export const Microdata = ({
  dateModified,
  datePublished,
  authorName,
  authorLinks,
  postId,
  postUrl,
  title,
  image,
}: IMicrodata) => {
  const authors = [] as typeof AUTHORS;

  if (authorLinks?.length) {
    authorLinks.map(({ name }) => {
      const author = AUTHORS.find(author => author.name === name);

      if (author) {
        authors.push(author);
      }
    });
  } else if (!authorName) {
    const author = AUTHORS.find(author => author.name === title);

    if (author) {
      authors.push(author);
    }
  }

  return (
    <>
      <meta itemProp="identifier" content={String(postId)} />
      <meta itemProp="inLanguage" content={'ru'} />
      <meta itemProp="image" content={image || undefined} />
      <meta itemProp="name" content={title} />
      <meta itemProp="url" content={`https://www.cian.ru${postUrl}`} />
      <link itemProp="mainEntityOfPage" href={`https://www.cian.ru${postUrl}`} />

      {authorName ? (
        <div itemProp="author" itemScope itemType="https://schema.org/Person">
          <meta itemProp="name" content={authorName || 'Циан Журнал'} />
          <meta itemProp="url" content="https://www.cian.ru/magazine/" />
        </div>
      ) : authors.length ? (
        authors.map((author, index) => (
          <div key={index} itemProp="author" itemScope itemType="https://schema.org/Person">
            {author.name && <meta itemProp="name" content={author.name} />}
            {author.url && <meta itemProp="url" content={author.url} />}
            {author.image && <meta itemProp="image" content={author.image} />}
            {author.jobTitle && <meta itemProp="jobTitle" content={author.jobTitle} />}
            {author.description && <meta itemProp="description" content={author.description} />}
            {author.gender && <meta itemProp="gender" content={author.gender} />}
            {author.email && <meta itemProp="email" content={author.email} />}
            {author.worksFor && <meta itemProp="worksFor" content={author.worksFor} />}
            {author.sameAs && <meta itemProp="sameAs" content={author.sameAs} />}
            {author.alumniOf && <meta itemProp="alumniOf" content={author.alumniOf} />}
            {author.knowsAbout && <meta itemProp="knowsAbout" content={author.knowsAbout} />}
            {author.hasCredential && <meta itemProp="hasCredential" content={author.hasCredential} />}
            {author.award && <meta itemProp="award" content={author.award} />}
          </div>
        ))
      ) : null}

      <div itemProp="publisher" itemScope itemType="https://schema.org/Organization">
        <meta itemProp="name" content="Циан Журнал" />
        <meta itemProp="logo" content={'https://content.cdn-cian.ru/realty/logo-cian.svg'} />
        <meta itemProp="url" content="https://www.cian.ru/magazine/" />
      </div>

      <meta itemProp="dateModified" content={toISOStringWithTimezone(new Date(dateModified))} />
      <meta itemProp="dateCreated" content={toISOStringWithTimezone(new Date(datePublished))} />
      <meta itemProp="datePublished" content={toISOStringWithTimezone(new Date(datePublished))} />
    </>
  );
};
